// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__VSEGV","colCheckbox":"styles_colCheckbox__193_5"};